<template>
  <fragment>
    <b-row class="geography-preference-input">
      <!-- <b-col cols="12">
        <div class="font_size_1200rem  my-2">
          <p>Select ‘No preference’ or indicate how you’d like to select your preferred location.</p>
        </div>
      </b-col> -->
      <div class="d-flex justify-content-start location-box position-relative">
        <b-form-radio-group
          stacked
          class=" "
          :checked="geographicPreferenceType"
          :options="geographicPreferenceOptions"
          @change="onChangeHandler"
        />
        <i
            class="mdi mdi-information-outline clickable region-modal-info-icon"
            aria-hidden="true"
            @click="isRegionModalVisible = true"
        />
      </div>
    </b-row>
    <region-form
      ref="preference_sub_form"
      v-if="geographicPreferenceType === 'region'"
      :preference-data="geographicPreferenceData"
      @set-preference="onUpdatePreference"
    />
    <state-geography-form
      ref="preference_sub_form"
      v-else-if="geographicPreferenceType === 'state'"
      :preference-data="geographicPreferenceData"
      @set-preference="onUpdatePreference"
    />
    <area-geography-form
      ref="preference_sub_form"
      v-else-if="geographicPreferenceType === 'metropolitan'"
      :preference-data="geographicPreferenceData"
      @set-preference="onUpdatePreference"
    />
    <b-modal 
      :visible="isRegionModalVisible"
      @hidden="isRegionModalVisible = false"
      hide-footer
      centered
      hide-header-close
      title="Geographic Selection"
      title-tag="h2"
      size="lg"
      class="geography-preference-modal-info"
    >
      <p class="my-2">
        Set your desired location for your Ideal Career Opportunity by selecting from the menu. If you are interested in job opportunities in multiple locations, you can create new ICOs in Connect.
      </p>
      <p class="mb-2">
        Select “Region / SubRegion” to include matching opportunities in a specific geographic region.
      </p>  
      <h6 class="font-weight-bold">
        States by Region:
      </h6>  
      <div>
        <div v-for="region in statesByRegion" :key="region.id">
          <b>
            {{ region.name }}:
          </b>
          <small>
            {{ region.states }}
          </small>
        </div>
      </div>
      <h6 class="font-weight-bold">
        States by SubRegion [Region]:
      </h6>
      <div class="mb-2">
        <div v-for="subregion in statesBySubRegion" :key="subregion.id">
          <b>
            {{ subregion.name }} ({{ subregion.region }}):
          </b>
          <small>
            {{ subregion.states }}
          </small>
        </div>
      </div>
      <p class="mb-2">
          Select a specific state, with the option to designate a specific city within that state.
      </p>
      <p class="mb-2">
        Select a specific “Metropolitan Area” and use the “Search” text box to enter the desired location and select from the matching results in the “Area” menu (some metro areas are further broken into distinct divisions which you can select if desired).
      </p>
      <div class="d-flex justify-content-center align-items-center w-100">
        <b-button
          variant="v2_primary"
          class="ml-1 width_140"
          @click="isRegionModalVisible = false"
        >
          Close
        </b-button>
      </div>
    </b-modal>
  </fragment>
</template>

<script>
import { validationMixin } from 'vuelidate';
import validateStateMixin from '@/mixins/validateStateMixin';
import RegionForm from '@/components/exchange/preference-charts-inputs/RegionForm';
import StateGeographyForm from '@/components/exchange/preference-charts-inputs/StateGeographyForm';
import AreaGeographyForm from '@/components/exchange/preference-charts-inputs/AreaGeographyForm';
import {
  GEOGRAPHIC_PREFERENCE,
  GEOGRAPHIC_PREFERENCE_OPTIONS_NAMES,
} from '@/helpers/jobQuestionsHelper';
import { required } from 'vuelidate/lib/validators';
import statesHelper from '@/helpers/StatesHelper';

export default {
  name: 'GeographyPreferenceInput',
  mixins: [validationMixin, validateStateMixin],
  components: {
    RegionForm,
    StateGeographyForm,
    AreaGeographyForm,
  },
  props: {
    jobQuestion: {
      type: Object,
      required: true,
    },
  },
  validations: {
    geographicPreferenceType: {
      required,
    },
  },
  computed: {
    geographicPreferenceData: function () {
      const variable = (this.jobQuestion.jobQuestionVariables || [])[0];
      return variable && Array.isArray(variable.jobProfileQuestionResponses)
        ? variable.jobProfileQuestionResponses[0]
        : null;
    },
    geographicPreferenceOptions: function () {
      return Object.keys(GEOGRAPHIC_PREFERENCE_OPTIONS_NAMES).map((key) => ({
        value: key,
        text: GEOGRAPHIC_PREFERENCE_OPTIONS_NAMES[key],
      }));
    },
    geographicPreferenceType: function () {
      return this.geographicPreferenceData
        ? this.geographicPreferenceData.type
        : null;
    },
    geographicPreferenceValue: function () {
      return this.geographicPreferenceData
        ? this.geographicPreferenceData.value
        : null;
    },
    statesByRegion() {
      let statesFormat = [];
      statesHelper.regions.forEach((region) => {
        statesFormat.push({
          name: region.name,
          states: statesHelper.states.filter(x => x.region_id === region.id)
            .map(x => x.abbrev)
            .join(', ')
        });
      });
      return statesFormat;
    },
    statesBySubRegion() {
      let statesFormat = [];
      statesHelper.subRegions.forEach((subRegion) => {
        statesFormat.push({
          name: subRegion.name,
          region: statesHelper.regions.find(x => x.id === subRegion.region_id).name,
          states: statesHelper.states.filter(x => x.sub_region_id === subRegion.id)
            .map(x => x.abbrev)
            .join(', ')
        });
      });
      return statesFormat;
    },
  },
  data() {
    return {
      isRegionModalVisible: false,
    };
  },
  methods: {
    onChangeHandler: function (checkedValue) {
      const displayName =
        checkedValue === GEOGRAPHIC_PREFERENCE.NO_PREFERENCE
          ? GEOGRAPHIC_PREFERENCE_OPTIONS_NAMES[
              GEOGRAPHIC_PREFERENCE.NO_PREFERENCE
            ]
          : null;
      this.$emit('set-preference', {
        type: checkedValue,
        value: displayName ? { display_name: displayName } : null,
      });
      this.$v.geographicPreferenceType.$touch();
    },
    onUpdatePreference: function () {
      this.$emit('set-preference', ...arguments);
    },
    isDirty: function () {
      return (
        this.$v.geographicPreferenceType.$dirty ||
        (this.$refs.preference_sub_form &&
          this.$refs.preference_sub_form.isDirty())
      );
    },
    resetValidation: function () {
      this.$v.geographicPreferenceType.$reset();
      if (this.$refs.preference_sub_form) {
        this.$refs.preference_sub_form.resetValidation();
      }
    },
    validate: function () {
      this.$v.$touch();
      if (this.$refs.preference_sub_form) {
        this.$refs.preference_sub_form.validate();
      }
    },
    hasErrors: function () {
      return (
        this.$v.$anyError ||
        (this.$refs.preference_sub_form &&
          this.$refs.preference_sub_form.hasErrors())
      );
    },
  },
  created: function () {
    if (
      this.geographicPreferenceType === GEOGRAPHIC_PREFERENCE.NO_PREFERENCE &&
      !this.geographicPreferenceValue
    ) {
      this.onChangeHandler(GEOGRAPHIC_PREFERENCE.NO_PREFERENCE);
    }
  },
};
</script>

<style lang="scss">
@import '../../../../sass/variables_mixins';
.geography-preference-input {
  .custom-control {
    margin: 0.5rem 0;
    .custom-control-label {
      padding-left: 0.5rem;
    }
  }
}
.location-box {
  padding: 15px;
  border: solid grey 1px;
  width: 850px;
  margin: 15px;
}
.region-modal-info-icon {
  position: absolute;
  top: 10px;
  right: 10px;
}
.geography-preference-modal-info {
  h6 {
    font-size: 1.125rem;
  }
}
</style>
